import type { ICustodian, ITradeRequest } from 'models/secondaryMarket';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { Thunk } from 'state/state.common';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

import type { DealSplit } from '../realtimeQuoteForm';
import { secondaryMarketTradeRequested } from './trade.actions';

function toCustodian(row: DealSplit): ICustodian {
  return { bdrId: row.custodianId!, notional: row.notional, bdrName: null! };
}

export function secondaryMarketTradeRequestThunk(tabId: string): Thunk<void> {
  return (dispatch, getState, { selectors: { fromSecondaryMarket } }) => {
    const state = getState();
    const quoteId = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormQuoteId(state, tabId);
    if (!quoteId) {
      return;
    }
    const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId);

    const correlationId = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteCorrelationId(state, quoteId);
    const priceType = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuotePriceType(state, quoteId);
    const upfrontFee = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteUpfrontFee(state, quoteId);
    const settlementDate = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteSettlementDate(state, quoteId);
    const settlementPrice = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteSettlementPrice(state, quoteId);
    const cashAmount = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteCashAmount(state, quoteId);
    const quotationType = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteQuotationType(state, quoteId);
    const price = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuotePrice(state, quoteId);
    const hasUpfront = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormHasUpfrontFee(state, tabId);
    const tradeSide = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormTradeWay(state, tabId);
    const client = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormClient(state, tabId);
    if (client === undefined || client.id === undefined || client.label === undefined) {
      getFrontLogger().error('can not trade as client is not found');
      return;
    }
    const dealSplitRows = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormDealSplitRows(state, tabId);
    const custodians = dealSplitRows.map(toCustodian);

    const tradeRequest: ITradeRequest = {
      correlationId: correlationId!,
      quoteId: quoteId!,
      settlementPrice: settlementPrice!,
      priceType: priceType!,
      upfrontFee: upfrontFee!,
      currency: product?.data?.currency!,
      hasUpfront: hasUpfront!,
      isin: product?.data?.isin!,
      maturityDate: product?.data?.maturityDate!,
      denomination: product?.data?.denomination!,
      tradeSide: tradeSide!,
      custodians: custodians!,
      client: { id: client.id, name: client.label, custodians },
      settlementDate: settlementDate!,
      cashAmount: cashAmount!,
      price: price!,
      quotationType: quotationType!,
      fileCode: product?.data?.fileCode!,
    };
    dispatch(secondaryMarketTradeRequested(tabId, quoteId, tradeRequest));
  };
}
